export default __webpack_public_path__ + "static/Duong_Do-b2de25a37d8e42ded373e69e894ffc1a.png";